
"use strict";

// ── PRIZES ──────────────────────────────────────────────────────
let PRIZES = [
  { w:250, label:"", icon:"", name:"", desc:"", light:true  },
  { w:220, label:"", icon:"", name:"", desc:"", light:false },
  { w:250, label:"", icon:"", name:"", desc:"", light:true  },
  { w:150, label:"", icon:"", name:"", desc:"", light:false },
  { w:130, label:"", icon:"", name:"", desc:"", light:true  },
];
const N      = PRIZES.length;
const TOTALW = PRIZES.reduce((s,p) => s + p.w, 0);
const ARC    = (2 * Math.PI) / N;
const ARCS   = PRIZES.map(() => ARC);

// ── CANVAS ──────────────────────────────────────────────────────
const canvas = document.getElementById("wc");
const ctx    = canvas.getContext("2d");
const CX = canvas.width  / 2;
const CY = canvas.height / 2;
const R       = CX - 18;
const R_INNER = 108;
const RIVETS  = 28;

// wheel center logo
const centerImg = new Image();
centerImg.src = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAgMjAwIj48dGV4dCB4PSIxMDAiIHk9Ijc4IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LWZhbWlseT0iR2VvcmdpYSxzZXJpZiIgZm9udC1zaXplPSI4IiBsZXR0ZXItc3BhY2luZz0iNSIgZmlsbD0iIzhCNzM1NSI+UElFUkNJTkcgSkVXRUxSWTwvdGV4dD48dGV4dCB4PSIxMDAiIHk9IjExNCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsc2VyaWYiIGZvbnQtc2l6ZT0iMzAiIGxldHRlci1zcGFjaW5nPSIyIiBmaWxsPSIjM2QzMjI4IiBmb250LXN0eWxlPSJpdGFsaWMiPkFuZ29yYTwvdGV4dD48bGluZSB4MT0iNTAiIHkxPSI5MCIgeDI9IjE1MCIgeTI9IjkwIiBzdHJva2U9IiNjNGE4ODIiIHN0cm9rZS13aWR0aD0iMC41Ii8+PC9zdmc+";

// ── DRAW WHEEL ───────────────────────────────────────────────────
function segStarts(base) {
  const s = []; let a = base;
  for (let i = 0; i < N; i++) { s.push(a); a += ARCS[i]; }
  return s;
}

function drawWheel(angle) {
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // outer glow
  const og = ctx.createRadialGradient(CX,CY,R-10,CX,CY,R+50);
  og.addColorStop(0,"rgba(196,168,130,0)");
  og.addColorStop(1,"rgba(139,115,85,0.15)");
  ctx.beginPath(); ctx.arc(CX,CY,R+50,0,2*Math.PI);
  ctx.fillStyle = og; ctx.fill();

  // rim
  ctx.beginPath(); ctx.arc(CX,CY,R+14,0,2*Math.PI);
  const rim = ctx.createLinearGradient(CX-R,CY-R,CX+R,CY+R);
  rim.addColorStop(0,"#edd8b8"); rim.addColorStop(0.5,"#c4a882"); rim.addColorStop(1,"#8B7355");
  ctx.fillStyle = rim; ctx.fill();

  // segments
  const starts = segStarts(angle);
  for (let i = 0; i < N; i++) {
    const sa = starts[i], ea = sa + ARCS[i], ma = sa + ARCS[i]/2;
    const p  = PRIZES[i];
    ctx.beginPath(); ctx.moveTo(CX,CY); ctx.arc(CX,CY,R,sa,ea); ctx.closePath();
    const gx1 = CX + R*.3*Math.cos(ma), gy1 = CY + R*.3*Math.sin(ma);
    const gx2 = CX + R*Math.cos(ma),    gy2 = CY + R*Math.sin(ma);
    const sg = ctx.createLinearGradient(gx1,gy1,gx2,gy2);
    if (p.light) { sg.addColorStop(0,"#fdfaf5"); sg.addColorStop(1,"#ede5d8"); }
    else         { sg.addColorStop(0,"#4a3e32"); sg.addColorStop(1,"#2a2118"); }
    ctx.fillStyle = sg; ctx.fill();
    ctx.strokeStyle = "rgba(196,168,130,0.55)"; ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.moveTo(CX,CY); ctx.arc(CX,CY,R,sa,ea); ctx.closePath(); ctx.stroke();

    // label + icon
    ctx.save(); ctx.translate(CX,CY); ctx.rotate(ma);
    const segInner = R_INNER + 10;
    const iconX    = R - 36;
    const fg = p.light ? "#3d3228" : "#f5f0e8";

    // icon bg
    ctx.beginPath(); ctx.arc(iconX,0,28,0,2*Math.PI);
    ctx.fillStyle = p.light ? "rgba(61,50,40,0.07)" : "rgba(245,240,232,0.08)";
    ctx.fill();

    // icon
    ctx.textAlign="center"; ctx.textBaseline="middle"; ctx.fillStyle=fg;
    ctx.font = p.icon==="✦" ? "bold 24px Cinzel,serif" : "28px serif";
    ctx.fillText(p.icon, iconX, 0);

    // text
    const lines = p.label.split("\n");
    const fs    = 22, lh = 27;
    const totalH = lines.length * lh;
    const tx = (segInner + iconX - 28) / 2;
    ctx.save(); ctx.translate(tx,0);
    lines.forEach((line,li) => {
      const y = -(totalH/2) + lh*.5 + li*lh;
      ctx.shadowColor = p.light ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.5)";
      ctx.shadowBlur=3; ctx.shadowOffsetY=1;
      ctx.fillStyle=fg;
      ctx.font = "700 "+fs+"px 'Cinzel',serif";
      ctx.fillText(line,0,y);
    });
    ctx.shadowColor="transparent"; ctx.shadowBlur=0;
    ctx.restore(); ctx.restore();
  }

  // rivets
  for (let i=0;i<RIVETS;i++) {
    const a  = (i/RIVETS)*2*Math.PI;
    const rx = CX+(R+8)*Math.cos(a), ry = CY+(R+8)*Math.sin(a);
    ctx.beginPath(); ctx.arc(rx,ry,5,0,2*Math.PI);
    const rg = ctx.createRadialGradient(rx-1.5,ry-1.5,0.5,rx,ry,5);
    rg.addColorStop(0,"#f0e0c0"); rg.addColorStop(1,"#8B7355");
    ctx.fillStyle=rg; ctx.fill();
    ctx.strokeStyle="rgba(139,115,85,0.4)"; ctx.lineWidth=0.5; ctx.stroke();
  }

  // border
  ctx.beginPath(); ctx.arc(CX,CY,R+0.5,0,2*Math.PI);
  ctx.strokeStyle="rgba(139,115,85,0.5)"; ctx.lineWidth=2; ctx.stroke();

  // center circle
  const cg = ctx.createRadialGradient(CX-15,CY-15,4,CX,CY,R_INNER);
  cg.addColorStop(0,"#fdfaf5"); cg.addColorStop(1,"#ede5d8");
  ctx.beginPath(); ctx.arc(CX,CY,R_INNER,0,2*Math.PI);
  ctx.fillStyle=cg; ctx.fill();
  ctx.strokeStyle="#c4a882"; ctx.lineWidth=2.5; ctx.stroke();
  ctx.beginPath(); ctx.arc(CX,CY,R_INNER-7,0,2*Math.PI);
  ctx.strokeStyle="rgba(196,168,130,0.35)"; ctx.lineWidth=1; ctx.stroke();

  // center logo / text
  if (centerImg.complete && centerImg.naturalWidth > 0) {
    ctx.save();
    const ls = R_INNER * 1.65;
    ctx.beginPath(); ctx.arc(CX,CY,R_INNER-3,0,2*Math.PI); ctx.clip();
    ctx.globalAlpha = 0.9;
    ctx.drawImage(centerImg, CX-ls/2, CY-ls/2, ls, ls);
    ctx.restore();
  } else {
    ctx.save(); ctx.textAlign="center"; ctx.textBaseline="middle";
    ctx.fillStyle="#8B7355"; ctx.font="italic 300 10px 'Cormorant Garamond',serif";
    ctx.fillText("PIERCING JEWELRY", CX, CY-28);
    ctx.fillStyle="#3d3228"; ctx.font="italic 300 28px 'Cormorant Garamond',serif";
    ctx.fillText("Angora", CX, CY-2);
    ctx.fillStyle="#8B7355"; ctx.font="400 9px 'Cinzel',serif";
    ctx.fillText("JEWELRY", CX, CY+22);
    ctx.restore();
  }

  // shine
  const sh = ctx.createRadialGradient(CX-18,CY-20,2,CX,CY,R_INNER);
  sh.addColorStop(0,"rgba(255,255,255,0.28)"); sh.addColorStop(1,"rgba(0,0,0,0)");
  ctx.beginPath(); ctx.arc(CX,CY,R_INNER,0,2*Math.PI);
  ctx.fillStyle=sh; ctx.fill();
}

function getPointerSegment(angle) {
  let rel = (-Math.PI/2 - angle) % (2*Math.PI);
  if (rel < 0) rel += 2*Math.PI;
  let cum = 0;
  for (let i=0;i<N;i++) { cum += ARCS[i]; if (rel < cum) return i; }
  return 0;
}

function easeOut(t) { return 1 - Math.pow(1-t, 4); }

// ── APP STATE ────────────────────────────────────────────────────
const DB_KEY  = "angora_participants_v2";
const ADMIN_PW = "angora2026";
const SHEETS_URL = "https://script.google.com/macros/s/AKfycbzt9GTpnCWF9LC7M9MM7EExbh5IlcghXEEQKDuXFcyJ9GEqbNKpVJnxOpsBiCMiz5tT/exec";

let user         = null;
let wAngle       = -Math.PI/2 - ARC/2;
let spinning     = false;
let spinsUsed    = 0;
let curPrize     = null;
let spinHistory  = [];

// ── STORAGE ──────────────────────────────────────────────────────
async function loadDB() {
  try { const r = await window.storage.get(DB_KEY,true); return r ? JSON.parse(r.value) : []; }
  catch(e) { try { return JSON.parse(localStorage.getItem(DB_KEY)||"[]"); } catch(e2) { return []; } }
}
async function saveDB(entry) {
  // Save to localStorage/storage as before (keeps existing functionality)
  try { const l=await loadDB(); l.push(entry); await window.storage.set(DB_KEY,JSON.stringify(l),true); }
  catch(e) { try { const l=JSON.parse(localStorage.getItem(DB_KEY)||"[]"); l.push(entry); localStorage.setItem(DB_KEY,JSON.stringify(l)); } catch(e2){} }
  // Also send to Google Sheets
  try {
    await fetch(SHEETS_URL, {
      method:"POST", redirect:"follow",
      headers:{"Content-Type":"text/plain"},
      body: JSON.stringify({action:"saveParticipant", participant:entry})
    });
  } catch(e) { console.warn("Sheets save failed:", e); }
  return true;
}

async function emailUsed(email) {
  const l = await loadDB();
  return l.some(p => p.email.toLowerCase()===email.toLowerCase());
}

// ── STEPS ────────────────────────────────────────────────────────
function goStep(n) {
  [1,2,3].forEach(i => {
    const el = document.getElementById("step"+i);
    el.className = "step" + (i<n?" done":i===n?" active":"");
    el.querySelector(".step-dot").textContent = i<n?"✓":String(i);
  });
  ["Register","Wheel","Final"].forEach((name,i) => {
    document.getElementById("panel"+name).classList.toggle("active", i+1===n);
  });
}

// ── REGISTER ─────────────────────────────────────────────────────
document.getElementById("btnRegister").addEventListener("click", async () => {
  const name  = document.getElementById("inputName").value.trim();
  const email = document.getElementById("inputEmail").value.trim();
  const phone = document.getElementById("inputPhone").value.trim();
  const ok    = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  document.getElementById("errName").classList.toggle("show",  !name);
  document.getElementById("errEmail").classList.toggle("show", !ok);
  document.getElementById("errPhone").classList.toggle("show", !phone);
  if (!name||!ok||!phone) return;

  const btn = document.getElementById("btnRegister");
  btn.disabled=true; btn.textContent="Verifying...";

  const used = await emailUsed(email);
  if (used) {
    document.getElementById("alreadyMsg").textContent="⚠ This email has already participated. One entry per person.";
    document.getElementById("alreadyMsg").classList.add("show");
    btn.disabled=false; btn.innerHTML="✦ &nbsp; SPIN THE WHEEL &nbsp; ✦";
    return;
  }

  user = {name,email,phone};
  resetSpinState();
  goStep(2);
  drawWheel(wAngle);
});

function resetSpinState() {
  spinsUsed=0; curPrize=null; spinHistory=[];
  wAngle = -Math.PI/2 - ARC/2;
  document.getElementById("spinBtn").innerHTML="✦ &nbsp; SPIN THE WHEEL! &nbsp; ✦";
  document.getElementById("spinBtn").style.display="";
  document.getElementById("actionBox").style.display="none";
}

function testMode() {
  user = {name:"Test Mode", email:"test@test.com", phone:"0000"};
  resetSpinState();
  goStep(2);
  drawWheel(wAngle);
}

// ── SPIN UI ──────────────────────────────────────────────────────
function updateDots() {
  [1,2,3].forEach(i => {
    const d = document.getElementById("dot"+i);
    if (i<=spinsUsed) { d.className="dot done"; d.textContent="✓"; }
    else if (i===spinsUsed+1 && spinsUsed<3) { d.className="dot pending"; d.innerHTML="SPIN<br>"+i; }
    else { d.className="dot"; d.innerHTML="SPIN<br>"+i; }
  });
}

function showActionBox() {
  const p       = PRIZES[curPrize];
  const remaining = 3 - spinsUsed;
  document.getElementById("spinStatus").innerHTML =
    "SPIN "+spinsUsed+" OF 3 &mdash; <span style='color:#8B7355;font-style:italic'>"+p.name+"</span>";
  document.getElementById("spinBtn").style.display="none";
  document.getElementById("actionBox").style.display="flex";
  document.getElementById("aIcon").textContent = p.icon;
  document.getElementById("aName").textContent = p.name;
  const respin = document.getElementById("btnRespin");
  if (remaining<=0) {
    document.getElementById("aSub").textContent  = "✦ Last spin — this is your final prize";
    respin.style.display="none";
    document.getElementById("btnClaim").innerHTML="✦ &nbsp; CLAIM MY PRIZE &nbsp; ✦";
  } else {
    document.getElementById("aSub").textContent  = remaining+" spin"+(remaining>1?"s":"")+" remaining";
    respin.style.display="";
    document.getElementById("btnClaim").innerHTML="✦ &nbsp; CLAIM THIS PRIZE &nbsp; ✦";
  }
}

// ── SPIN LOGIC ───────────────────────────────────────────────────
function pickWinner() {
  const used   = new Set(spinHistory);
  const pool   = PRIZES.map((p,i)=>({i,w:p.w})).filter(x=>!used.has(x.i));
  const active = pool.length>0 ? pool : PRIZES.map((p,i)=>({i,w:p.w}));
  const tot    = active.reduce((s,x)=>s+x.w,0);
  let   rand   = Math.random()*tot, cum=0;
  for (const x of active) { cum+=x.w; if (rand<=cum) return x.i; }
  return active[active.length-1].i;
}

document.getElementById("spinBtn").addEventListener("click", doSpin);
document.getElementById("btnClaim").addEventListener("click", claimPrize);
document.getElementById("btnRespin").addEventListener("click", () => {
  curPrize=null;
  document.getElementById("actionBox").style.display="none";
  document.getElementById("spinBtn").style.display="";
  document.getElementById("spinBtn").innerHTML="✦ &nbsp; SPIN AGAIN &nbsp; ✦";
  document.getElementById("spinStatus").textContent="SPIN "+(spinsUsed+1)+" OF 3";
  updateDots();
});

function doSpin() {
  if (spinning) return;
  spinning=true;
  document.getElementById("spinBtn").disabled=true;
  canvas.classList.add("spinning");

  const winner = pickWinner();
  let offset   = 0;
  for (let i=0;i<winner;i++) offset+=ARCS[i];
  offset += ARCS[winner]/2;

  const extra   = (5+Math.random()*3)*2*Math.PI;
  let delta     = -Math.PI/2 - offset - wAngle;
  delta = ((delta%(2*Math.PI))+(2*Math.PI))%(2*Math.PI);
  if (delta<0.1) delta+=2*Math.PI;
  delta+=extra;

  const t0 = performance.now();
  const dur = 4000+Math.random()*1400;
  const sa  = wAngle;

  function frame(now) {
    const t = Math.min((now-t0)/dur,1);
    wAngle   = sa + delta*easeOut(t);
    drawWheel(wAngle);
    if (t<1) { requestAnimationFrame(frame); return; }
    wAngle   = (sa+delta)%(2*Math.PI);
    drawWheel(wAngle);
    spinning=false;
    canvas.classList.remove("spinning");
    document.getElementById("spinBtn").disabled=false;
    curPrize = getPointerSegment(wAngle);
    spinHistory.push(curPrize);
    spinsUsed++;
    updateDots();
    showActionBox();
  }
  requestAnimationFrame(frame);
}

async function claimPrize() {
  if (curPrize===null) return;
  const p    = PRIZES[curPrize];
  const code = "ANGORA-"+Math.random().toString(36).substring(2,7).toUpperCase();
  const entry= {name:user.name,email:user.email,phone:user.phone,prize:p.name,spinsUsed,code,
    date:new Date().toLocaleString("es-CO",{timeZone:"America/Bogota"})};

  goStep(3);
  launchConfetti();
  document.getElementById("fIcon").textContent  = p.icon;
  document.getElementById("fPrize").textContent = p.name;
  document.getElementById("fDesc").textContent  = p.desc;
  document.getElementById("fCode").textContent  = code;
  document.getElementById("fName").textContent  = user.name;
  document.getElementById("fSave").textContent  = "Saving your entry...";

  const ok = await saveDB(entry);
  document.getElementById("fSave").textContent = ok
    ? "✓ Entry saved successfully"
    : "⚠ Could not save — note your code: "+code;
}

function launchConfetti() {
  const colors=["#c4a882","#e8d5b7","#f5f0e8","#8B7355","#d4b896","#fff"];
  for (let i=0;i<60;i++) setTimeout(()=>{
    const el=document.createElement("div");
    el.className="cp";
    el.style.left=Math.random()*100+"vw"; el.style.top="-10px";
    el.style.background=colors[Math.floor(Math.random()*colors.length)];
    el.style.width=(4+Math.random()*7)+"px"; el.style.height=(4+Math.random()*7)+"px";
    el.style.borderRadius=Math.random()>.5?"50%":"1px";
    el.style.animationDuration=(2+Math.random()*2)+"s";
    document.body.appendChild(el); setTimeout(()=>el.remove(),4500);
  },i*40);
}

function restart() {
  user=null; resetSpinState();
  ["inputName","inputEmail","inputPhone"].forEach(id=>document.getElementById(id).value="");
  document.getElementById("alreadyMsg").classList.remove("show");
  ["errName","errEmail","errPhone"].forEach(id=>document.getElementById(id).classList.remove("show"));
  document.getElementById("btnRegister").disabled=false;
  document.getElementById("btnRegister").innerHTML="✦ &nbsp; SPIN THE WHEEL &nbsp; ✦";
  goStep(1);
}

// ── ADMIN ────────────────────────────────────────────────────────
// ── PRIZE EDITOR ────────────────────────────────────────────────
function buildPrizeEditor() {
  const container = document.getElementById("prizeEditor");
  container.innerHTML = "";
  const totalW = PRIZES.reduce((s,p)=>s+p.w,0);

  PRIZES.forEach((p,i) => {
    const pct = Math.round((p.w/totalW)*100);
    const row = document.createElement("div");
    row.className = "prize-editor-row";
    row.innerHTML = `
      <div class="row-top">
        <div class="pe-icon">
          <label>Icon</label>
          <input type="text" id="pe_icon_${i}" value="${p.icon}" maxlength="4">
        </div>
        <div class="pe-name">
          <label>Name (shown in result)</label>
          <input type="text" id="pe_name_${i}" value="${p.name}">
        </div>
      </div>
      <div class="pe-desc">
        <label>Wheel label (use \\n for line breaks)</label>
        <input type="text" id="pe_label_${i}" value="${p.label.replace(/\n/g,"\\n")}">
      </div>
      <div class="pe-desc" style="margin-bottom:0">
        <label>Description (shown when winning)</label>
        <input type="text" id="pe_desc_${i}" value="${p.desc}">
      </div>
      <div class="pe-weight" style="margin-top:10px">
        <label>Probability</label>
        <input type="range" class="pe-slider" id="pe_w_${i}" min="0" max="100" value="${pct}"
          oninput="onSlider(${i},this.value)"
          style="--val:${pct}%">
        <span class="pe-pct" id="pe_pct_${i}">${pct}%</span>
      </div>`;
    container.appendChild(row);
  });
  updateTotal();
}

function onSlider(i, val) {
  const slider = document.getElementById("pe_w_"+i);
  slider.style.setProperty("--val", val+"%");
  document.getElementById("pe_pct_"+i).textContent = val+"%";
  updateTotal();
}

function updateTotal() {
  let tot = 0;
  PRIZES.forEach((_,i) => {
    tot += parseInt(document.getElementById("pe_w_"+i)?.value||0);
  });
  const el = document.getElementById("peTotal");
  el.textContent = "Total: "+tot+"% "+(tot===100?"✓ Perfect":"— must equal 100%");
  el.className = "pe-total "+(tot===100?"ok":"warn");
}

function applyPrizeEdits() {
  let tot = 0;
  PRIZES.forEach((_,i) => tot += parseInt(document.getElementById("pe_w_"+i).value||0));
  if (tot===0) { alert("Total cannot be 0%"); return; }

  // Convert percentages to weights (multiply by 10 to keep integers)
  PRIZES.forEach((p,i) => {
    const pct   = parseInt(document.getElementById("pe_w_"+i).value||0);
    p.w         = pct * 10;  // scaled weight
    p.icon      = document.getElementById("pe_icon_"+i).value.trim() || p.icon;
    p.name      = document.getElementById("pe_name_"+i).value.trim() || p.name;
    p.label     = document.getElementById("pe_label_"+i).value.replace(/\\n/g,"\n");
    p.desc      = document.getElementById("pe_desc_"+i).value.trim() || p.desc;
  });

  // Recalc ARCS and redraw
  const newTotalW = PRIZES.reduce((s,p)=>s+p.w,0);
  // ARCS stays equal (visual segments equal) — only internal weights change
  // Redraw wheel with new labels/icons
  drawWheel(wAngle);
  // Also refresh stats
  renderAdmin();

  // Save prizes to Google Sheets
  try {
    const prizesToSave = PRIZES.map(p => ({
      icon: p.icon, name: p.name, label: p.label,
      desc: p.desc, weight_pct: Math.round(p.w/10)
    }));
    fetch(SHEETS_URL, {
      method:"POST", redirect:"follow",
      headers:{"Content-Type":"text/plain"},
      body: JSON.stringify({action:"savePrizes", prizes: prizesToSave})
    }).catch(e => console.warn("Sheets prizes save failed:", e));
  } catch(e) {}

  const msg = document.getElementById("applyMsg");
  msg.style.display="inline";
  setTimeout(()=>msg.style.display="none",2500);
}

function openAdmin()  { document.getElementById("adminOverlay").classList.add("show"); }
function closeAdmin() {
  document.getElementById("adminOverlay").classList.remove("show");
  document.getElementById("adminContent").style.display="none";
  document.getElementById("adminPw").value="";
}
async function checkAdmin() {
  if (document.getElementById("adminPw").value!==ADMIN_PW) { alert("Incorrect password"); return; }
  document.getElementById("adminContent").style.display="block";
  buildPrizeEditor();
  await renderAdmin();
}
async function renderAdmin() {
  const list = await loadDB();
  const counts={};
  PRIZES.forEach(p=>counts[p.name]=0);
  list.forEach(e=>{ if(counts[e.prize]!==undefined) counts[e.prize]++; });
  const tot=list.length;
  const bars=PRIZES.map(p=>{
    const n=counts[p.name]||0, pct=tot>0?Math.round(n/tot*100):0;
    return `<div style="margin-bottom:8px">
      <div style="display:flex;justify-content:space-between;margin-bottom:3px">
        <span style="font-family:'Cinzel',serif;font-size:.6rem;color:#8B7355;text-transform:uppercase">${p.icon} ${p.name}</span>
        <span style="font-family:'Cormorant Garamond',serif;color:#3d3228">${n} (${pct}%)</span>
      </div>
      <div style="height:3px;background:rgba(139,115,85,.12);border-radius:2px">
        <div style="height:3px;background:#c4a882;border-radius:2px;width:${pct}%"></div>
      </div></div>`;
  }).join("");
  document.getElementById("adminStats").innerHTML=
    `<div style="font-family:'Cormorant Garamond',serif;margin-bottom:12px;color:#3d3228"><strong>${tot}</strong> participant(s)</div>
     <div style="background:rgba(255,255,255,.6);border:1px solid rgba(196,168,130,.25);padding:14px 18px;margin-bottom:12px">${bars}</div>`;
  const tbody=document.getElementById("adminBody");
  tbody.innerHTML=!list.length
    ? '<tr><td colspan="8" style="text-align:center;color:#bbb;padding:20px;font-style:italic">No entries yet</td></tr>'
    : list.map((e,i)=>`<tr><td>${i+1}</td><td>${e.name}</td><td>${e.email}</td><td>${e.phone}</td><td><strong>${e.prize}</strong></td><td>${e.spinsUsed||"-"}</td><td style="font-family:monospace;font-size:.8rem;color:#8B7355">${e.code}</td><td style="font-size:.8rem;color:#aaa">${e.date}</td></tr>`).join("");
}
function exportCSV() {
  loadDB().then(list=>{
    if(!list.length){alert("No data");return;}
    const h=["#","Name","Email","Phone","Prize","Spins","Code","Date"];
    const r=list.map((e,i)=>[i+1,e.name,e.email,e.phone,e.prize,e.spinsUsed||"-",e.code,e.date]);
    const csv=[h,...r].map(row=>row.map(v=>'"'+String(v).replace(/"/g,'""')+'"').join(",")).join("\n");
    const a=document.createElement("a");
    a.href=URL.createObjectURL(new Blob([csv],{type:"text/csv"}));
    a.download="angora_participants_"+new Date().toISOString().split("T")[0]+".csv";
    a.click();
  });
}
async function clearAll() {
  if(!confirm("Delete ALL records? Cannot be undone.")) return;
  try{await window.storage.delete(DB_KEY,true);}catch(e){}
  try{localStorage.removeItem(DB_KEY);}catch(e){}
  await renderAdmin();
}

// ── INIT ─────────────────────────────────────────────────────────
// Draw immediately with defaults
centerImg.onload = () => drawWheel(wAngle);
if (centerImg.complete) drawWheel(wAngle);
else drawWheel(wAngle);

// Load prizes + config from Google Sheets and apply
(async () => {
  try {
    const res  = await fetch(SHEETS_URL + "?action=getAll", {redirect:"follow"});
    const data = await res.json();

    // Apply prizes if returned
    if (data.prizes && data.prizes.length === PRIZES.length) {
      data.prizes.forEach((saved, i) => {
        if (!PRIZES[i]) return;
        if (saved.icon)       PRIZES[i].icon  = saved.icon;
        if (saved.name)       PRIZES[i].name  = saved.name;
        if (saved.label)      PRIZES[i].label = saved.label;
        if (saved.desc)       PRIZES[i].desc  = saved.desc;
        if (saved.weight_pct) PRIZES[i].w     = saved.weight_pct * 10;
      });
      drawWheel(wAngle); // redraw with updated labels/icons
      updatePrizePreview();
    }

    // Apply event title if returned
    if (data.config) {
      if (data.config.event_title) {
        const el = document.getElementById("eventTitle");
        if (el) el.textContent = data.config.event_title;
      }
      if (data.config.event_subtitle) {
        const el = document.getElementById("eventSubtitle");
        if (el) el.textContent = data.config.event_subtitle;
      }
      if (data.config.instruction) {
        const el = document.getElementById("instrText");
        if (el) el.innerHTML = data.config.instruction;
        const title = document.getElementById("instrTitle");
        if (title) title.textContent = "How to Play";
      }
      if (data.config.footer_text) {
        const el = document.getElementById("footerText");
        if (el) el.textContent = data.config.footer_text;
      }
      // Show instruction box only after content is ready
      const box = document.getElementById("instrBox");
      if (box) box.style.display = "";
    }
  } catch(e) {
    console.warn("Sheets load failed, using defaults:", e);
  }
})();

function updatePrizePreview() {
  const list = document.getElementById("prizePreviewList");
  if (!list) return;
  list.innerHTML = PRIZES.map(p =>
    `<div class="prize-item"><span>${p.icon}</span><div><strong>${p.name.toUpperCase()}</strong><p>${p.desc}</p></div></div>`
  ).join("");
}